/* eslint-disable no-console */

import React from 'react'

import Note from '../../components/Note'


export default (props) => (<Note {...props} />)
